import { collection, addDoc, query, where, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

class FacilityService {
    async requestFacility(facilityData) {
        try {
            const docRef = await addDoc(collection(db, 'facility_requests'), {
                ...facilityData,
                requested_at: new Date(),
                status: 'pending'
            });
            
            return { 
                success: true, 
                message: 'Facility request submitted successfully!', 
                id: docRef.id 
            };
        } catch (error) {
            console.error('Error requesting facility:', error);
            return { 
                success: false, 
                message: error.message || 'Failed to request facility'
            };
        }
    }

    async getUserFacilityRequests(userId) {
        try {
            const q = query(
                collection(db, 'facility_requests'), 
                where('user_id', '==', userId)
            );
            const querySnapshot = await getDocs(q);
            
            const requests = [];
            querySnapshot.forEach((doc) => {
                requests.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            
            return requests;
        } catch (error) {
            console.error('Error fetching facility requests:', error);
            return [];
        }
    }

    async removeFacilityRequest(facilityId) {
        try {
            await deleteDoc(doc(db, 'facility_requests', facilityId));
            return { 
                success: true, 
                message: 'Facility request removed successfully' 
            };
        } catch (error) {
            console.error('Error removing facility request:', error);
            return { 
                success: false, 
                message: error.message || 'Failed to remove facility request'
            };
        }
    }
}

export default FacilityService;

